import axiosInstance from "./axiosInstance";

const purchaseService = {
    create: async (payload) => {
        try {
            const response = await axiosInstance.post('/medicine-stocks/create', payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetchAll: async () => {
        try {
            const response = await axiosInstance.get('/pharmacyPurchase/all');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetchTotal: async () => {
        try {
            const response = await axiosInstance.get('/pharmacyPurchase/total');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetchById: async (id) => {
        try {
            const response = await axiosInstance.get('/pharmacyPurchase/get/' + id);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    update: async (id, payload) => {
        try {
            const response = await axiosInstance.post(`/medicine-stocks/edit/${id}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    approvePurchase: async (id, discount) => {
        try {
            const response = await axiosInstance.post(`/pharmacyPurchase/approve/${id}`, { discount });
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    }
};

export default purchaseService;